import action from "../helpers/rest-client";

export class ErrorPlan extends Error {}

class Plan {
  public new(payload) {
    return action
      .Post({
        url: "/payments/plans",
        body: payload,
      })
      .then((response) => {
        return { response };
      })
      .catch((error) => {
        return { error };
      });
  }
  public getAll(payload) {
    if (payload?.filterBy) {
      payload.filterBy = JSON.stringify(payload?.filterBy);
    }

    if (payload?.select) {
      payload.select = JSON.stringify(payload?.select);
    }

    const queryString = new URLSearchParams(payload).toString();

    return action
      .Get({
        url: `/payments/plans?platform=CONSTANA${
          queryString ? "&" + queryString : ""
        }`,
      })
      .then((response) => {
        return { response };
      })
      .catch((error) => {
        return { error };
      });
  }
  public updated(payload) {
    return action
      .Post({
        url: `/payments/plans`,
        body: payload,
      })
      .then((response) => {
        return { response };
      })
      .catch((error) => {
        return { error };
      });
  }
  public delete({ _id }) {
    return action
      .Del({
        url: `/payments/plans/${_id}`,
      })
      .then((response) => {
        return { response };
      })
      .catch((error) => {
        return { error };
      });
  }
}

const plan = new Plan();
export default plan;
